import React from "react";
import PracticsQuestionTopics from "../../topics/PracticsQuestionTopics";


function DiagramQuestionBioTopics() {
  return (
    <>

      <PracticsQuestionTopics subject="biology" type="diagrambasedquestions" />

    </>
  );
}

export default DiagramQuestionBioTopics;